import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'account-signup',
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/AccountSignUpPageContainer'),
  }),
};
